import type { InjectionKey, Ref } from 'vue';

/**
 * Куда попапы выносят содержимое: селектор ближайшего окна, иначе `body`.
 * Селектор, а не элемент: заглушка Teleport в спеках пишет `to` в атрибут, а happy-dom приводит
 * элемент к его outerHTML, и вложенные попапы раздувают атрибуты экспоненциально.
 */
export const OVERLAY_HOST: InjectionKey<Readonly<Ref<string | null>>> = Symbol('overlay-host');
